import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import store from '../redux/store';

const PrivateRoutesAdmin = ({ children }) => {
  const TokenAdmin = store.getState().admin;
  const location = useLocation();
  const lang = location.pathname.startsWith('/fr') ? 'fr' : 'en';
  return TokenAdmin.Token !== '' && TokenAdmin.status
    ? children
    : <Navigate to={`/${lang}/public/admin/sign-in`} />;
};

export default PrivateRoutesAdmin;
